import React from 'react'
import { Container } from '@mui/material';

import { withStyles } from '@mui/styles'

import { ProfileUser } from '../../../features/profile'
import { profileStyles } from './profile.styles'

export const ProfilePage = withStyles(profileStyles)(({ classes }) => {
  return (
    <div className={classes.root}>
      <Container className={classes.container} maxWidth="md">
        <ProfileUser forceOpenEdit={false} />
      </Container>
    </div>
  )
})
